import React from 'react'
import {Layout} from "../../../../palette/Palette";
import {Chart, Export, SeriesTemplate, CommonSeriesSettings, Legend} from 'devextreme-react/chart';
import VerticalSpace from "../../../../palette/VerticalSpace";
import Alerts from "../../../../palette/Alerts";


function BookingTrend(props) {

    const {status} = props

    return (
        <>
            {status?.length > 0 ?
                <Layout>
                    <VerticalSpace space={10}/>
                    <Chart id="chart" dataSource={status} title={'Tendencia de reserva trimestral'}
                           style={{padding: 10}}>

                        <CommonSeriesSettings
                            argumentField="status"
                            valueField="total_status"
                            type="bar"
                            ignoreEmptyPoints={true}
                        />
                        <SeriesTemplate nameField="status"/>
                        <Legend verticalAlignment="horizontal" horizontalAlignment="center" orientation={'horizontal'}/>
                        <Export enabled={true}/>
                    </Chart>
                </Layout> : <div style={{marginTop: 10, padding: 5}}>
                    <Alerts severity="warning" body={'Aún no se han realizado viajes.'}/>
                </div>}
        </>
    )
}


export default BookingTrend